import { useSyncExternalStore, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { TenantScopeSwitcher } from "../../../components/TenantScopeSwitcher";
import { onTenantScopeChange, tenantScope } from "../../../lib/tenantScope";

/** Do not mount preparation queries until the user has explicitly selected a cabinet. */
export function PreparationCabinetGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const scope = useSyncExternalStore(onTenantScopeChange, tenantScope, () => null);
  if (!scope)
    return (
      <section
        className="space-y-4 rounded-xl border border-slate-200 bg-white p-5"
        aria-labelledby="prepare-cabinet-title"
      >
        <h1 id="prepare-cabinet-title" className="text-xl font-semibold text-slate-900">
          {t("prepare_cabinet.title")}
        </h1>
        <p className="text-sm text-slate-600">{t("prepare_cabinet.description")}</p>
        <TenantScopeSwitcher initialSelectionDestination="current" />
      </section>
    );
  return <div key={scope}>{children}</div>;
}
